import ErrorHandler from '@schachermayer/sch-vuejs-commons/src/errors';
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { UrlApi } from '../../../build/swagger-code-extranet-api-definition/apis/url-api';
import { UrlStorage } from '../../../build/swagger-code-extranet-api-definition/models';

const urlApi: UrlApi = new UrlApi({ basePath: process.env.VUE_APP_CONTEXT_BASE });

@Module({
    namespaced: true,
    name: 'urlStorage',
})
export default class UrlStorageModule extends VuexModule {
    public urlStorage: UrlStorage = {};

    @Mutation
    public setUrlStorage(urlStorage: UrlStorage): void {
        this.urlStorage = urlStorage;
    }

    @Action({ commit: 'setUrlStorage' })
    async loadUrls(): Promise<UrlStorage> {
        try {
            return (await urlApi.getUrls({ credentials: 'same-origin' })).data;
        } catch (error) {
            ErrorHandler.handleError(error);
            return {};
        }
    }

}
